import { render, staticRenderFns } from "./slot1.vue?vue&type=template&id=527eb09d&scoped=true&"
import script from "./slot1.vue?vue&type=script&lang=js&"
export * from "./slot1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527eb09d",
  null
  
)

export default component.exports